import { take } from 'rxjs/operators';
import { FeatureFlagManagerService } from './feature-flag-manager.service';
import { IFlaggableComponent } from './feature-flag-model';

export function FeatureFlag(
	flagKey: string,
	defaultValue: boolean = false,
): (target: IFlaggableComponent, propertyKey: string) => void {
	return function (target: IFlaggableComponent, propertyKey: string) {
		const ngOnInitOriginal = target.ngOnInit;
		target.ngOnInit = function (): void {
			const ldService: FeatureFlagManagerService = this.featureFlagManagerService;

			if (!ldService) {
				console.error('FeatureFlagManagerService not found in component');
				return;
			}

			ldService.flags$.pipe(take(1)).subscribe((flags) => {
				this[propertyKey] = flags[flagKey] ?? defaultValue;
			});

			if (ngOnInitOriginal) {
				ngOnInitOriginal.apply(this);
			}
		};
	};
}
